$(function() {
    'use strict';

    var $slider = $('.slider__el');

    if ($slider.length > 0) {

        var autoplayEnabled = $slider.data('autoplay');

        $slider.slick({
            infinite: true,
            dots: false,
            arrows: false,
            speed: 1000,
            slidesToShow: 1,
            lazyLoad: 'ondemand',
            autoplay: autoplayEnabled,
            autoplaySpeed: 2000,
            fade: true,
            cssEase: 'linear'
        });

        $('.slider__item_link_next').on('click', function(event) {
            event.preventDefault();

            $slider.slick('slickNext');
        });
    }

});